import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-insider",
  // imports: [],
  templateUrl: "./insider.component.html",
  styleUrl: "./insider.component.css",
  standalone: false,
})
export class InsiderComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"] && changes["isActive"].currentValue === true) {
    }
  }
}
